import React, {useState} from 'react';
import './NavSection.css';

const NavSection = () => {

    const handleClick = () => {
        document.body.classList.toggle('nav-open');
    }

    return(
        <body class="tile">
            <header>
                <div class="logo">
                    TH.
                </div>
                <div class="header-right">
                    <div class="nav-buttons">
                        <a href="#Home" class="nav-btn">Home</a>
                        <a href="#exp" class="nav-btn">Experiences</a>
                        <a href="#about" class="nav-btn">About Me</a>
                        <a href="#Skills" class="nav-btn">Skills</a>
                        <a href="#Projects" class="nav-btn">My Projects</a>
                    </div>
                    <button class="nav-toggle" aria-label="toggle navigation" onClick={handleClick}>
                        <span class="hamburger"></span>
                    </button>
                </div>
                <nav class="nav">
                    <u1 class="nav__list">
                        <li class="nav__item" onClick={handleClick}><a href="#Home" class="nav__link">Home</a></li>
                        <li class="nav__item" onClick={handleClick}><a href="#exp" class="nav__link">My Experiences</a></li>
                        <li class="nav__item" onClick={handleClick}><a href="#about" class="nav__link">About Me</a></li>
                        <li class="nav__item" onClick={handleClick}><a href="#Skills" class="nav__link">My Skills</a></li>
                        <li class="nav__item" onClick={handleClick}><a href="#Projects" class="nav__link">My Projects</a></li>
                    </u1>
                </nav>
            </header>
        </body>
    )
}

export default NavSection;